import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Splide from '@splidejs/splide';

const productsCarousels = new WeakMap();

export default function InitSplide() {
    productSlider();
    productsCarousel();
    initContentSlider();
    categorySlider();
};

function productsCarousel() {
    document.querySelectorAll('.splide.ng-products-carousel').forEach((root) => {
        if (productsCarousels.has(root) || root.querySelectorAll('.ng-products-grid > .splide__slide').length < 2) {
            return;
        }

        const carousel = new Splide(root, {
            type: 'slide',
            fixedWidth: 'calc((100% - 20px) / 1.5)',
            gap: 20,
            perMove: 1,
            arrows: true,
            pagination: false,
            autoplay: false,
            dragMinThreshold: { mouse: 4, touch: 10 },
            // Partial destruction keeps Splide's media listener for mobile remounts.
            destroy: true,
            breakpoints: {
                700: { destroy: false },
            },
            i18n: {
                prev: root.dataset.previousLabel,
                next: root.dataset.nextLabel,
                carousel: root.dataset.carouselLabel,
                slide: root.dataset.slideLabel,
                slideLabel: root.dataset.slideCountLabel,
            },
        });

        productsCarousels.set(root, carousel);
        carousel.mount();
    });
}

function productSlider() {
    const splides = document.querySelectorAll('.splide.product_splide');

    if (splides.length) {
        splides.forEach((splide) => {
            new Splide(splide, {
                type: 'slide',
                pagination: false,
                arrows: true,
                cover: false,
                autoWidth: true,
                perMove: 2,
            }).mount();
        });
    }
}

function categorySlider() {
    const selector = '.splide[data-splide-categories]';
    if (!$(selector).length) return;
    let collectionSliders = document.querySelectorAll(selector);
    for (let i = 0; i < collectionSliders.length; i++) {
        let splideElement = collectionSliders[i];
        let splide = new Splide(splideElement, {
            pagination: false,
            drag: 'free',
            arrows: false,
            autoWidth: true,
            mediaQuery: 'min',
            breakpoints: {
                1081: {
                    arrows: true,
                },
            }
        });
        splide.mount();
    }
}

export function getMainSplide(selector) {
    return new Splide(selector, {
        type: 'slide',
        pagination: false,
        arrows: false,
        cover: false,
        autoWidth: true,
        perMove: 1,
        lazyLoad: 'sequential'
    });
}

function getThumbnailSplide(selector) {
    return new Splide(selector, {
        rewind: true,
        autoWidth: true,
        isNavigation: true,
        gap: 0,
        focus: 'left',
        pagination: false,
        cover: false,
        arrows: false,
        dragMinThreshold: {
            mouse: 4,
            touch: 10,
        },
    });
}

function initContentSlider() {
    const parentSelector = 'section.testimonials';
    const selector = $(parentSelector + ' .splide.testimonial_slider');
    if (selector.length) {
        selector.each(function () {
            const parent = $(this).closest(parentSelector);
            const thumbnailSelector = parent.find('.content-thumbnail-splide');
            if (thumbnailSelector.length) {
                let mainSplide = getMainSplide(this);
                let thumbnailSplide = getThumbnailSplide(thumbnailSelector[0]);
                mainSplide.sync(thumbnailSplide);
                mainSplide.mount();
                thumbnailSplide.mount();
                mainSplide.go(0);
                thumbnailSplide.go(0);
            }
        });
    }
}
